module.exports = __webpack_public_path__ + "static/media/view6_front.189bcd56.png";